import { z } from "zod";

const hhmm = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, "Expected HH:mm");
const date = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Expected YYYY-MM-DD");

const slotInputSchema = z.object({
  age_group_id: z.string().min(1).optional().nullable(),
  team_id: z.string().min(1).optional().nullable(),
  court_id: z.string().min(1).optional().nullable(),
  slot_starts_at_local: hhmm,
  slot_duration_mins: z.number().int().positive().max(600),
  label: z.string().max(200).optional().nullable(),
  sort_order: z.number().int().optional(),
});

export const createEventSeriesSchema = z
  .object({
    name: z.string().min(1).max(200),
    event_type: z.string().max(40).optional().default("practice"),
    sport_id: z.string().min(1).optional().nullable(),
    days_of_week: z.array(z.number().int().min(0).max(6)).min(1).max(7),
    starts_on: date,
    ends_on: date,
    default_starts_at_local: hhmm,
    default_duration_mins: z.number().int().positive().max(600).default(90),
    slots: z.array(slotInputSchema).max(50).default([]),
  })
  .refine((v) => v.starts_on <= v.ends_on, { message: "ends_on must be >= starts_on" });

export const updateEventSeriesSchema = z.object({
  name: z.string().min(1).max(200).optional(),
  sport_id: z.string().min(1).optional().nullable(),
  days_of_week: z.array(z.number().int().min(0).max(6)).min(1).max(7).optional(),
  starts_on: date.optional(),
  ends_on: date.optional(),
  default_starts_at_local: hhmm.optional(),
  default_duration_mins: z.number().int().positive().max(600).optional(),
  slots: z.array(slotInputSchema).max(50).optional(),
});

export type CreateEventSeriesInput = z.infer<typeof createEventSeriesSchema>;
export type UpdateEventSeriesInput = z.infer<typeof updateEventSeriesSchema>;
export type EventSeriesSlotInput = z.infer<typeof slotInputSchema>;
